import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { AppActions, SearchResultActions } from "../../redux/reducer";
import store from "../../redux/store";
import { errHandler } from "./errorHandler";

export const reqHandler = (config: AxiosRequestConfig) => config;

export const reqErrHandler = (error: AxiosError) => Promise.reject(error);

export const resHandler = (response: AxiosResponse<any>) => {
  if (
    response.data &&
    response.data.status === "nok" &&
    response.config.url &&
    response.config.url.indexOf("favorites") === -1
  ) {
    store.dispatch(AppActions.setErrorPage(true));
    return Promise.reject(response);
  }
  if (response.data) return response.data;
  return Promise.reject(response);
};

export const resErrHandler = (error: AxiosError) => {
  // handle error here
  errHandler(error);
  // clear
  store.dispatch(SearchResultActions.setItemLoadingStatus(false));
  store.dispatch(SearchResultActions.setOutfitLoadingStatus(false));
  store.dispatch(SearchResultActions.setOutfitHasNextPageLoadingStatus(false));
  return Promise.reject(error);
};
